import type { Location, NavigationAction } from '@app/packages/routing/types'

import { clearRouterErrorSlice } from '@app/store/slices/error'
import { resetMetaSlice } from '@app/store/slices/meta'
import { clearProfileUpdateSlice } from '@app/store/slices/profile'
import { beginRoutingSlice, commitRoutingSlice } from '@app/store/slices/routing'
import { hideSideMenuOnNavigateSlice } from '@app/store/slices/ui_menu'
import { createThunk } from '@app/store/thunk'

/**
 * A route began resolving. Everything scoped to the outgoing route resets here rather than in a
 * case handler per slice, so no slice can miss it by not having been evaluated yet.
 */
export const beforeNavigate = (payload: { initial: boolean; location: Location; action: NavigationAction }) =>
  createThunk(dispatch => {
    dispatch(beginRoutingSlice(payload.initial))
    // The initial navigation renders the meta the server already resolved.
    if (!payload.initial) dispatch(resetMetaSlice())
    dispatch(clearProfileUpdateSlice())
    dispatch(clearRouterErrorSlice())
  })

/** A route committed. */
export const navigate = (payload: { location: Location; action: NavigationAction }) =>
  createThunk(dispatch => {
    dispatch(commitRoutingSlice())
    dispatch(hideSideMenuOnNavigateSlice(payload))
  })
